function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree, Modal, Table, Tabs } from 'antd';
import { NodePlusFill, XSquareFill, TrashFill, PencilFill, BoxArrowInRight, PlusCircleFill, BoxSeamFill } from 'react-bootstrap-icons';
import Common from "../components/includes/Common";
import AddConnsumable from "../components/forms/AddConsumable";
import AddConsumableCategory from "../components/forms/AddConsumableCategory";
import EditConsumable from "../components/forms/EditConsumable";
import ConsumablesOut from "../components/ConsumablesOut";
import NewProvision from "../components/forms/NewProvision";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Consommable = function Consommable() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isNewDeptFormVisible = _useState2[0],
      setIsNewDeptFormVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isNewItemFormVisible = _useState4[0],
      setIsNewItemFormVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dataChanged = _useState6[0],
      setDataChanged = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedItem = _useState8[0],
      setSelectedItem = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      itemProvisionVisible = _useState10[0],
      setItemProvisionVisible = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      itemEditVisible = _useState12[0],
      setItemEditVisible = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      itemsArray = _useState14[0],
      setItemsArray = _useState14[1];

  var _useState15 = useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      isDataLoading = _useState16[0],
      setIsDataLoading = _useState16[1];

  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Cat\xE9gorie"
    }),
    dataIndex: "category",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "category"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte Disponible"
    }),
    dataIndex: "available_quantity",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "available_quantity"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Stock Minimale"
    }),
    dataIndex: "minimal_stock",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "minimal_stock"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Actions"
    }),
    dataIndex: "action",
    render: function render(item) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleEditItem(item);
          },
          children: /*#__PURE__*/_jsx(PencilFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleDeleteItem(item);
          },
          children: /*#__PURE__*/_jsx(TrashFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          style: {
            color: '#EF7B7A'
          },
          onClick: function onClick() {
            return handleItemIn(item);
          },
          children: /*#__PURE__*/_jsx(PlusCircleFill, {
            size: 28
          })
        })]
      });
    },
    key: "action"
  }];

  var handleEditItem = function handleEditItem(item) {
    setSelectedItem(item);
    setItemEditVisible(true);
  };

  var handleDeleteItem = function handleDeleteItem(item) {
    setSelectedItem(item);
    Modal.confirm({
      title: "Confirmez-vous ?",
      content: "La suppression de " + item.label,
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteconsumable/" + item.id.toString() + "/" + Common.currentUser.id.toString()).then(function (response) {
          if (response.status == 200) {
            setDataChanged(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };

  var handleItemIn = function handleItemIn(item) {
    setSelectedItem(item);
    setItemProvisionVisible(true);
  };

  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getconsumables').then(function (response) {
      if (response.data.status == 200) {
        setItemsArray([]);
        response.data.consumables.forEach(function (s) {
          setItemsArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              id: s.id,
              key: s.id.toString() + "tab",
              label: s.label,
              category: s.category.label,
              cost_price: s.cost_price,
              available_quantity: s.available_quantity,
              minimal_stock: s.minimal_stock,
              action: s
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                width: '98%',
                background: '#EF7B7A'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewDeptFormVisible(true);
              },
              children: "Ajouter une categorie"
            }), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                width: '98%',
                background: '#EF7B7A'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewItemFormVisible(true);
              },
              children: "Ajouter un Consommable"
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Tabs, {
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BoxArrowInRight, {
                  size: 28
                }), " SORTIE"]
              }),
              children: /*#__PURE__*/_jsx(ConsumablesOut, {})
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BoxSeamFill, {
                  size: 28
                }), " ETATS DU STOCK"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "white-bg cool-radius",
                children: /*#__PURE__*/_jsx(Table, {
                  size: "small",
                  columns: cols,
                  bordered: true,
                  sticky: false,
                  loading: isDataLoading,
                  dataSource: itemsArray,
                  pagination: true
                })
              })
            }, 2)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un d\xE9partement",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddConsumableCategory, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewItemFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un acte/examen",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddConnsumable, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: itemEditVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Modifier",
      onCancel: function onCancel() {
        setItemEditVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(EditConsumable, {
        handler: function handler() {
          setDataChanged(true), setItemEditVisible(false);
          message.success({
            content: "Modifications enregistrées",
            delay: 4
          });
        },
        item: selectedItem
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: itemProvisionVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Entr\xE9e de Stock",
      onCancel: function onCancel() {
        setItemProvisionVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(NewProvision, {
        item: selectedItem,
        handler: function handler() {
          setDataChanged(true), setItemProvisionVisible(false);
          message.success({
            content: "Opération effectuée",
            delay: 4
          });
        }
      })
    })]
  });
};

export default Consommable;